/* Reopen Shopify's own consent dialog without changing a visitor's choice. */
(() => {
  const button = document.querySelector('[data-vovi-privacy-settings]');
  const status = document.querySelector('[data-vovi-privacy-status]');
  if (!button || !status) return;
  let loading;
  function banner() {
    if (window.privacyBanner?.showPreferences) return Promise.resolve(window.privacyBanner);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const finish = error => {
        clearTimeout(timer);
        script.onload = script.onerror = null;
        if (error) { script.remove(); reject(error); }
        else resolve(window.privacyBanner);
      };
      const timer = setTimeout(() => finish(Error('timeout')), 12000);
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.async = true;
      script.onload = () => finish(window.privacyBanner?.showPreferences ? null : Error('unavailable'));
      script.onerror = () => finish(Error('load'));
      document.head.append(script);
    }).catch(error => { loading = undefined; throw error; });
    return loading;
  }
  button.addEventListener('click', async () => {
    if (button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.hidden = true;
    try {
      const api = await banner();
      // Safari does not focus pointer-activated buttons. Give the native dialog
      // a focusable return target before it records the previously active element.
      button.disabled = false;
      button.focus({ preventScroll: true });
      await api.showPreferences();
    } catch {
      status.textContent = 'Die Cookie-Einstellungen konnten nicht geöffnet werden. Bitte lade die Seite neu und versuche es erneut. Deine bisherige Auswahl wurde nicht geändert.';
      status.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
